import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { projects } from "../data/projects";

const Portfolio = () => {
  return (
    <section id="work" className="icg-section">
      <div className="icg-container">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <span className="icg-eyebrow"><span className="icg-dot" /> Selected work</span>
            <h2
              className="font-display font-semibold tracking-tight mt-5"
              style={{ fontSize: "clamp(36px, 5vw, 64px)", lineHeight: 1.02 }}
            >
              Work led by our
              <br />
              <span className="font-serif-it text-[color:var(--icg-accent)]">CEO & Lead Designer</span>.
            </h2>
            <p className="mt-6 text-[color:var(--icg-muted)] max-w-lg leading-relaxed">
              A selection of enterprise UX, product design and brand work led by Monica Lockett
              across Comcast, AT&T, UPS, State Farm and more.
            </p>
          </div>
          <a href="#contact" className="icg-link text-sm font-medium">
            I want the same <ArrowUpRight size={14} />
          </a>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((p, i) => (
            <Link
              key={p.slug}
              to={`/work/${p.slug}`}
              className={`icg-tile icg-lift ${i % 4 === 1 ? "lg:mt-12" : ""} ${
                i % 4 === 2 ? "lg:-mt-6" : ""
              }`}
            >
              <img
                src={p.cover}
                alt={p.title}
                className="icg-tile__img"
                loading="lazy"
              />
              <div className="icg-tile__overlay">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="text-xs uppercase tracking-widest opacity-80">
                      {p.client} · {p.category} · {p.year}
                    </div>
                    <div className="font-display text-2xl font-semibold mt-1">
                      {p.title}
                    </div>
                  </div>
                  <span
                    className="h-10 w-10 rounded-full flex items-center justify-center shrink-0"
                    style={{ background: p.color, color: "#fff" }}
                  >
                    <ArrowUpRight size={16} />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
